export default __webpack_public_path__ + "static/media/sell-02.2795a60b.png";